import { createContext } from 'react'
import { observable, computed, runInAction } from 'mobx'

import SessionStore from 'stores/session/SessionStore'
import Session, { MODEL_LIST_SESSION_ID } from 'stores/session/Session'

// Why does this exist?
// The currently active session is so commonly used to make decisions in components that it makes more sense to have a global React context rather than pass it to all component props
// Components ALWAYS get the current session they're being used in from their contexts
// Stores can get it from the TabStore

// The reason components cannot get the active session from the tab is because sessions are not limited to being loaded only in tabs. Sessions can be loaded in any component.
// Since only sessions can hold a script, if you want access to multiple scripts, multiple sessions must be loaded.
// This means that multiple sessions might be rendered inside a tab. Example: RecordConnectModal loads a different session in itself.
// If components always relied on the tab's active session, this would not have been possible.

interface SessionContextCreatePayload {
  sessionId: string
}

export class SessionContext {
  // @ts-ignore | TS complains it is not definiteily assigned in the constrcutor, but it is
  @observable sessionId: string

  constructor(sessionContext: SessionContextCreatePayload) {
    runInAction(() => {
      this.sessionId = sessionContext.sessionId
    })
  }

  @computed
  get session(): Session | null {
    return SessionStore.get(this.sessionId)
  }
}

export const fallbackSessionContext = new SessionContext({
  sessionId: MODEL_LIST_SESSION_ID,
})

const ReactContext = createContext<SessionContext>(fallbackSessionContext)

export const SessionContextProvider = ReactContext.Provider
export const SessionContextConsumer = ReactContext.Consumer
export const SessionContextType = ReactContext
